var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 0.179688H6.14314C6.06457 0.179688 6.00028 0.243973 6.00028 0.322545V1.32254C6.00028 1.40112 6.06457 1.4654 6.14314 1.4654H15.0003C15.0789 1.4654 15.1431 1.40112 15.1431 1.32254V0.322545C15.1431 0.243973 15.0789 0.179688 15.0003 0.179688ZM15.0003 7.75112H6.14314C6.06457 7.75112 6.00028 7.8154 6.00028 7.89397V8.89397C6.00028 8.97255 6.06457 9.03683 6.14314 9.03683H15.0003C15.0789 9.03683 15.1431 8.97255 15.1431 8.89397V7.89397C15.1431 7.8154 15.0789 7.75112 15.0003 7.75112ZM15.0003 11.5368H1.00028C0.921708 11.5368 0.857422 11.6011 0.857422 11.6797V12.6797C0.857422 12.7583 0.921708 12.8225 1.00028 12.8225H15.0003C15.0789 12.8225 15.1431 12.7583 15.1431 12.6797V11.6797C15.1431 11.6011 15.0789 11.5368 15.0003 11.5368ZM15.0003 3.9654H1.00028C0.921708 3.9654 0.857422 4.02969 0.857422 4.10826V5.10826C0.857422 5.18683 0.921708 5.25112 1.00028 5.25112H15.0003C15.0789 5.25112 15.1431 5.18683 15.1431 5.10826V4.10826C15.1431 4.02969 15.0789 3.9654 15.0003 3.9654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align-right.aa5a8da3dfdae98261cfa2fba76dcd09.svg";
export { ForwardRef as ReactComponent };